import { WhoWillReceiveCareAdoptionStep } from "../steps/views/WhoWillReceiveCareAdoptionStep"
import { RelatedToAdoptingSpouseChildStep } from "../steps/views/RelatedToAdoptingSpouseChildStep"
import { AdoptionSteps, GeneralSteps, SectionName } from "#/components/carrot-card-cost-share/workflows/step-library"
import { ExpenseNotCoveredStep } from "#/components/carrot-card-cost-share/steps/views/ExpenseNotCoveredStep"

export enum Workflows {
  ADOPTION = "Adoption Workflow"
}

export const adoptionSteps = [
  { name: AdoptionSteps.WHO_WILL_RECEIVE_CARE_ADOPTION, component: WhoWillReceiveCareAdoptionStep },
  { name: AdoptionSteps.RELATED_TO_ADOPTING_SPOUSE_CHILD, component: RelatedToAdoptingSpouseChildStep },
  { name: AdoptionSteps.EXPENSE_NOT_COVERED_ADOPTION, component: ExpenseNotCoveredStep }
]

//prettier-ignore
const adoptionFlow: AdoptionFlowTransition[] = [
  { at: AdoptionSteps.WHO_WILL_RECEIVE_CARE_ADOPTION,     given: "ELIGIBLE",     goto: AdoptionSteps.RELATED_TO_ADOPTING_SPOUSE_CHILD },
  { at: AdoptionSteps.WHO_WILL_RECEIVE_CARE_ADOPTION,     given: "INELIGIBLE",   goto: AdoptionSteps.EXPENSE_NOT_COVERED_ADOPTION },
  { at: AdoptionSteps.RELATED_TO_ADOPTING_SPOUSE_CHILD,   given: "",             goto: GeneralSteps.TOTAL_COST, sectionName: SectionName.GENERAL },
  { at: AdoptionSteps.EXPENSE_NOT_COVERED_ADOPTION,       given: "",             end: true }
]

type AdoptionFlowTransition =
  | { at: AdoptionSteps; given: string; goto: AdoptionSteps; sectionName?: undefined }
  | { at: AdoptionSteps; given: string; goto: GeneralSteps; sectionName: string }
  | { at: AdoptionSteps; given: string; end: true }

export const adoptionWorkflows = [{ name: Workflows.ADOPTION, workflow: adoptionFlow }]
